import { render, staticRenderFns } from "./TaskAdd.vue?vue&type=template&id=5d82ffcb&scoped=true&"
import script from "./TaskAdd.vue?vue&type=script&lang=js&"
export * from "./TaskAdd.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdd.vue?vue&type=style&index=0&id=5d82ffcb&prod&lang=scss&"
import style1 from "./TaskAdd.vue?vue&type=style&index=1&id=5d82ffcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82ffcb",
  null
  
)

export default component.exports